/* eslint-disable eqeqeq */
import { Box, ThemeProvider, Typography, Link } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AppBaseScreen from "../../components/AppBaseScreen";
import { theme } from "./theme";
import { useDispatch, useSelector } from "react-redux";
import Check from "../../assets/logo/check.svg";
import {
  enableMFA,
  getPayeeData
} from "../../store/actions";
import AppButton from "../../components/AppButton";
import { logEvent } from "../../store/api";
import { ACTIVITY_DETAIL, ACTIVITY_META, EVENTS } from "../../utils/events";
import { useLocation } from "react-router-dom";
import { MFA_GUIDE_LINK } from "../../utils/config";

const MFA = () => {
  const params = useParams();
  const isMfaEnabled = useSelector(({ Auth }) => Auth?.user?.isMfaEnabled);
  const user = useSelector(({ Auth }) => Auth?.user);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    if (params?.active) {
      handleEnableMFA(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleEnableMFA = (isPopup) => {
    if (!isLoading) {
      logEvent({
        current: EVENTS['2FA']['2FA_SETUP'],
        activity: ACTIVITY_DETAIL['2FA']['2FA_SETUP'],
        meta: {
          data: {
            pathname: location.pathname,
            source: isPopup == 1? ACTIVITY_META['2FA']['FROM_POPUP']: ACTIVITY_META['2FA']['FROM_MENU']
          }
        }
      });
      setLoading(true);
      dispatch(enableMFA(user.email, { isPopup: isPopup == 1, location}, onComplete));
    }    
  }

  const onComplete = () => {
    dispatch(getPayeeData());
    setLoading(false);
  };

  return (
    <AppBaseScreen isHeader={true}>
      <ThemeProvider theme={theme}>
        <Box
          padding={2}
          sx={{ marginTop: 15, backgroundColor: "rgba(0, 136, 245, 0.15)" }}
          borderRadius={3}
        >
          <Typography fontSize={24} color={"#D4D4D8"} fontWeight="bold" textAlign="center">
            { t("mfa.title") }
          </Typography>
          <Box marginTop={2}>
            <Typography fontSize={16} color={"#ddd"}>
            { t("mfa.text1") }
            </Typography>
          </Box>          
          <Box marginTop={2}>
            <Typography
              fontSize={16}
              fontFamily="Manrope"
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Check style={{ width: 20, height: 20 }} /> &nbsp;&nbsp; { t("mfa.feature1") }
            </Typography>
            <Typography
              fontSize={16}
              fontFamily="Manrope"
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Check style={{ width: 20, height: 20 }} /> &nbsp;&nbsp; { t("mfa.feature2") }
            </Typography>
          </Box>
          {!isMfaEnabled ? 
            (
              <Box marginTop={2}>
                <Typography fontSize={16} color={"#ddd"}>
                  {t('2fa-p3_a')} <Link href="mailto:support@rocketfuel.inc" target="_blank" color={"#0088F5"}>support@rocketfuel.inc</Link>      {t('2fa-p3_b')}
     
                </Typography> 
              </Box>
            ) :
            (
              <Box marginTop={2}>
                <Typography fontSize={16} color={"#ddd"}>
                  Please contact us at <Link href="mailto:support@rocketfuel.inc" target="_blank" color={"#0088F5"}>support@rocketfuel.inc</Link> to turn off 2FA.
                </Typography>
              </Box>
            )          
          }
          <Box marginTop={2}>
            <Typography fontSize={16} color={"#ddd"}>
              { t("mfa.clickLearn") } <Link href={MFA_GUIDE_LINK} target="_blank" color={"#0088F5"}>{ t("mfa.clickLearn2") }</Link>
            </Typography>
          </Box>
          <Box marginTop={2}>
            <Typography fontSize={16} color={"#ddd"}>
            { t("mfa.text2") } { isMfaEnabled ? 'On' : 'Off'}
            </Typography>
          </Box>
          {!isMfaEnabled && (<Box marginTop={2}>
            <AppButton
              title={t("mfa.text3")}
              onClick={handleEnableMFA}
              sx={{ width: 100, margin: "auto", fontSize: 12 }}
              loading={isLoading}
            />
          </Box>)}
        </Box>
      </ThemeProvider>
    </AppBaseScreen>
  );
};

export default MFA;
